module.exports = __webpack_public_path__ + "static/media/documents-tran.6cddc734.png";